var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 199.33 199.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#5876b3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 199.33,
    height: 199.34,
    rx: 21.8,
    ry: 21.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.64,43.04c-.48,9.17-13.6,9.24-13.6,0s13.12-9.17,13.6,0c.3,5.81,9.39,5.85,9.08,0-.45-8.65-6.75-16.28-15.88-16.28s-15.85,7.61-15.88,16.28,6.74,15.97,15.26,16.25c9.38.31,16.03-7.3,16.5-16.25.3-5.84-8.78-5.82-9.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.1,138.18v-55.89c0-4.07-.28-6.49-2.87-9.72-2.04-2.55-4.58-4.51-7.58-5.79-5.88-2.52-12.5-1.78-17.73,1.88-3.34,2.34-6.52,5.62-6.72,9.82-.42,9.19-.09,18.49-.13,27.68-.09,18.78-.17,37.57-.26,56.35-.01,2.45,2.09,4.54,4.54,4.54h42.23c2.45,0,4.54-2.08,4.54-4.54v-87.46l-4.54,4.54h23.86l-4.54-4.54v10.13c0,3.74,5.1,6.25,7.75,3.21,6.16-7.07,14.13-9.05,23.18-8.29,8.09.68,18.93,5.61,21.99,13.86,1.37,3.7.25,9.79.25,13.97v53.79l4.54-4.54h-25.86l4.54,4.54v-46.56c0-4.65.55-8.79-2.13-12.72s-6.28-6.79-10.73-8c-5.34-1.46-11.14-.22-15.56,3.03-1.94,1.42-4.31,3.56-5.09,5.92-1.01,3.09-.21,7.9-.24,11.16-.13,15.92-.25,31.84-.38,47.75-.05,5.85,9.04,5.85,9.08,0,.1-12.27.19-24.54.29-36.81.04-5.71-.81-12.29.14-17.91.84-4.98,8.06-5.67,11.78-3.3,1.57,1,3.94,3.28,4.3,5.26-.21-1.14-.55,1.65-.55,1.74-.13,1.58,0,3.26,0,4.85v45.59c0,2.45,2.08,4.54,4.54,4.54h25.86c2.45,0,4.54-2.08,4.54-4.54v-64.55c0-5.71-1.74-8.9-5.38-13.26-13.49-16.15-41.36-18.23-55.55-1.96l7.75,3.21v-10.13c0-2.45-2.08-4.54-4.54-4.54h-23.86c-2.45,0-4.54,2.08-4.54,4.54v87.46l4.54-4.54h-42.23l4.54,4.54c.07-15.16.14-30.32.21-45.48.03-7.25.07-14.5.1-21.75.02-3.95.04-7.91.05-11.86,0-.74-.2-4.06-.24-3.88-.05.27.04-.31.24-.69,1.95-3.87,7.57-5.3,11.32-3.94,7.58,2.74,5.43,10.85,5.43,17.36v45.91c0,5.84,9.08,5.85,9.08,0h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.9adfdf53075fdfbdee7a2f1fddd840e6.svg";
export { ForwardRef as ReactComponent };